<template>
  <v-card
    tile
    outlined
    :width="width ? width : 'auto'"
    :height="height ? height : 'auto'"
    :class="{
      selected: selected
    }"
    @click="onClick"
  >
    <v-img
      v-if="imgSrc"
      aspect-ratio="1"
      max-height="340px"
      class="grey lighten-2"
      :src="imgSrc"
    >
      <v-overlay absolute v-if="selected && multiple" opacity="0.25">
        <v-btn fab depressed>
          <v-icon class="display-2">
            mdi-check
          </v-icon>
        </v-btn>
      </v-overlay>

      <template v-slot:placeholder>
        <v-row class="fill-height ma-0" align="center" justify="center">
          <v-progress-circular indeterminate color="grey lighten-5">
          </v-progress-circular>
        </v-row>
      </template>
      <v-tooltip top v-if="infoDialogTitle || infoDialogText">
        <template v-slot:activator="{ on }">
          <v-btn
            absolute
            fab
            class="theme--dark mt-7"
            small
            depressed
            v-on="on"
            v-bind="position"
            @click="onInfoClick"
          >
            <v-icon color="white">mdi-information</v-icon>
          </v-btn>
        </template>
        <span>
          More information
        </span>
      </v-tooltip>
    </v-img>
    <v-container class="pl-5 pt-4 pr-5 pb-3" fluid>
      <v-row v-if="imgSrc" no-gutters>
        <v-col>
          <v-card-title
            class="black--text font-weight-bold"
            :class="{
              'text-uppercase': uppercaseTitle,
              selected: selected
            }"
          >
            {{ title }}
          </v-card-title>
        </v-col>
        <v-col v-if="displayAddButton" cols="2" md="3" lg="2">
          <v-btn dark fab top right small depressed>
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-else no-gutters justify="space-between">
        <v-col>
          <v-card-title
            class="black--text font-weight-bold"
            :class="{
              'text-uppercase': uppercaseTitle,
              selected: selected
            }"
          >
            {{ title }}
          </v-card-title>
        </v-col>
        <v-col cols="2" md="3" lg="2" class="text-right">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn fab right small depressed v-on="on" @click="onInfoClick">
                <v-icon color="black" size="x-large">mdi-information</v-icon>
              </v-btn>
            </template>
            <span>
              {{ $t("components.Widgets.CheckboxCard.additionalInformation") }}
            </span>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-container>
    <v-container v-if="subTitle" class="pl-5 pt-0 pr-5 pb-8">
      <v-card-text class="black--text" v-html="subTitle" />
      <div class="sale-label" v-if="saleLabelSpotlight.length">
        <p class="sale-label-text"> {{ saleLabelSpotlight }} </p>
      </div>
      <span class="card__label" v-if="label.length && !saleLabelSpotlight.length">
        {{ label }}
      </span>
    </v-container>
    <card-info-dialog
      v-if="infoDialogTitle && infoDialogText"
      :showDialog="showInfoDialog"
      :dialogHeader="dialogHeader"
      @closeDialog="showInfoDialog = false"
    >
      <h2 class="pb-9 text-h3 text-uppercase">{{ infoDialogTitle }}</h2>
      <v-img v-if="infoDialogImage" :src="infoDialogImage" />
      <p class="black--text text-body-1">{{ infoDialogText }}</p>
    </card-info-dialog>
  </v-card>
</template>

<script>
import CardInfoDialog from "./CardInfoDialog";

export default {
  name: "CheckboxCard",
  components: {
    CardInfoDialog
  },
  props: {
    id: {
      type: [Number, String],
      description:
        "The card's id, can be used by the parent for checking which card \
                      has been selected (will $emit in onClick/onInfoClick events)"
    },
    title: {
      type: String,
      description: "Title of the card"
    },
    subTitle: {
      type: String,
      description: "Subtitle of the card"
    },
    selected: {
      type: Boolean,
      default: false,
      description: "State of selection of the card"
    },
    multiple: {
      type: Boolean,
      default: false,
      description:
        "Means the card is in group which could working in multiply mode, \
                      also will show checkbox icon on card."
    },
    displayAddButton: {
      type: Boolean,
      default: false,
      description: "Display a + icon / add button next to the card's title"
    },
    uppercaseTitle: {
      type: Boolean,
      default: false,
      description: "Convert the title of the card to uppercase"
    },
    imgSrc: {
      type: [String, undefined],
      default: undefined,
      description: "Source of the card's image"
    },
    dialogHeader: {
      type: [String, undefined],
      default: "",
      description: "Header of dialog"
    },
    infoDialogTitle: {
      type: [String, undefined],
      default: "",
      description:
        "Title of info popup dialog. The card will show a simple \
                      AlertDialog if infoDialogTitle and infoDialogText are set"
    },
    infoDialogText: {
      type: [String, undefined],
      default: "",
      description:
        "Text of info popup dialog. The card will show a simple \
                      AlertDialog if infoDialogTitle and infoDialogText are set"
    },
    infoDialogImage: {
      type: String,
      default: "",
      description: "Image for info card"
    },
    height: {
      type: [String, undefined],
      description: "The height of the card"
    },
    width: {
      type: [String, undefined],
      description: "The width of the card"
    },
    position: {
      type: Object,
      default: () => ({
        left: true,
        top: true
      })
    },
    label: {
      type: String,
      default: "",
      description: "Display label"
    },
    saleLabelSpotlight: {
      type: String,
      default: "",
      description: "Discount label with custom text for spotlight"
    }
  },
  data() {
    return {
      showInfoDialog: false
    };
  },
  methods: {
    onClick() {
      this.$emit("onClick", this.id);
    },
    onInfoClick(event) {
      this.showInfoDialog = true;
      this.$emit("onInfoClick", this.id);
      event.stopPropagation();
    }
  }
};
</script>

<style lang="scss" scoped>
.sale-label {
  position: absolute;
  top: 10px;
  right: 10px;
  border-radius: 15%;
  background: rgb(3, 29, 79);
  height: 30px;
  width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 500;
  color: white;
  .sale-label-text {
    margin: 0;
  }
}
::v-deep.v-card {
  flex: 1;
  text-align: left;
  border-width: 2px !important;

  &.selected {
    border: 2px solid var(--v-primary-base);
  }

  &__title {
    &.selected {
      color: var(--v-primary-base) !important;
    }

    padding: 0;
    font-size: 15px !important;
    word-break: break-word;
  }

  &__text {
    padding: 0;
  }

  &--link:focus:before {
    opacity: 0;
  }

  .v-image .v-icon.v-icon {
    font-size: 25px;
  }

  .v-size--small {
    width: 20px;
    height: 20px;
  }
}
</style>
